import * as ENV from "./environment";
import {
	isArrayOfLength,
	isOfLength,
	isStringOfLength,
	tokenReplacement
} from "@pheaa/channels-component-library";

export const API_NSP_AUTH = "auth";
export const API_NSP_DOCUMENTS = "documents";
export const API_NSP_ERROR_REPORTING = "error-reporting";
export const API_NSP_PROFILE = "profile";

export const API_NSP_OPERATION_CODES_COUNTRY = "codes-country";
export const API_NSP_OPERATION_CODES_STATE = "codes-state";
export const API_NSP_OPERATION_EXTEND = "extend";
export const API_NSP_OPERATION_INBOX = "inbox";
export const API_NSP_OPERATION_INBOX_DOCUMENT_BY_ID = "inbox-document-by-id";
export const API_NSP_OPERATION_INBOX_TAX_SUMMARY_BY_ID = "inbox-tax-summary-by-id";
export const API_NSP_OPERATION_INCIDENTS = "incidents";
export const API_NSP_OPERATION_INCIDENTS_ANONYMOUS = "anonymous-incidents";
export const API_NSP_OPERATION_LOGIN = "login";
export const API_NSP_OPERATION_LOGOUT = "logout";
export const API_NSP_OPERATION_LOGOUT_REDIRECT = "logout-redirect";
export const API_NSP_OPERATION_MAINTENANCE = "maintenance";
export const API_NSP_OPERATION_PROFILE = "profile";
export const API_NSP_OPERATION_PROFILE_CONTACTS_ADDRESSES = "profile-contacts-addresses";
export const API_NSP_OPERATION_PROFILE_CONTACTS_EMAILS = "profile-contacts-emails";
export const API_NSP_OPERATION_PROFILE_CONTACTS_PHONES = "profile-contacts-phones";
export const API_NSP_OPERATION_TERMS = "terms";
export const API_NSP_OPERATION_TOKEN_EXCHANGE = "token-exchange";
export const API_NSP_OPERATION_VERIFY = "verify";

// TODO: Confirm this object contains relevant Guaranty & Cognito endpoints, not local;
const api = {
	[`${API_NSP_AUTH}.${API_NSP_OPERATION_TOKEN_EXCHANGE}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/exchangeTokens.json?code={{tokenExchangeId}}`,
			url: "https://auth.api.{{env}}.pheaa.org/token-exchange?code={{tokenExchangeId}}"
		}
	},
	[`${API_NSP_AUTH}.${API_NSP_OPERATION_VERIFY}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/verifyTokens.json`,
			url: "https://auth.api.{{env}}.pheaa.org/verify"
		}
	},
	[`${API_NSP_AUTH}.${API_NSP_OPERATION_EXTEND}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/extendSession.json`,
			url: "https://auth.api.{{env}}.pheaa.org/extend"
		}
	},
	[`${API_NSP_AUTH}.${API_NSP_OPERATION_LOGIN}`]: {
		default: {
			url: "https://auth.{{env}}.pheaa.org/login?client_id={{authClientId}}&response_type=code&scope=email+openid+phone+profile&redirect_uri=https%3A%2F%2Faccount.{{env}}.pheaa.org"
		},
	},
	[`${API_NSP_AUTH}.${API_NSP_OPERATION_LOGOUT}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/endSession.json`
			url: "https://auth.api.{{env}}.pheaa.org/logout"
		}
	},
	[`${API_NSP_AUTH}.${API_NSP_OPERATION_LOGOUT_REDIRECT}`]: {
		default: {
			url: "https://auth.{{env}}.pheaa.org/logout?client_id={{authClientId}}&logout_uri=https%3A%2F%2Fwww.{{env}}.pheaa.org%2Floan-default%2Findex.shtml"
		}
	},
	[`${API_NSP_ERROR_REPORTING}.${API_NSP_OPERATION_INCIDENTS}`]: {
		default: {
			url: "https://api.{{env}}.aessuccess.org/error-reporting/v1/incidents"
		}
	},
	[`${API_NSP_ERROR_REPORTING}.${API_NSP_OPERATION_INCIDENTS_ANONYMOUS}`]: {
		default: {
			url: "https://api.{{env}}.aessuccess.org/error-reporting/v1/anonymous-incidents"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_MAINTENANCE}`]: {
		default: {
			url: "https://profile.api.{{env}}.pheaa.org/maintenance"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_PROFILE}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/getProfile.json`
			url: "https://profile.api.{{env}}.pheaa.org/profiles/me"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_PROFILE_CONTACTS_ADDRESSES}`]: {
		default: {
			url: "https://profile.api.{{env}}.pheaa.org/profiles/me/contacts/addresses"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_PROFILE_CONTACTS_EMAILS}`]: {
		default: {
			url: "https://profile.api.{{env}}.pheaa.org/profiles/me/contacts/emails"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_PROFILE_CONTACTS_PHONES}`]: {
		default: {
			url: "https://profile.api.{{env}}.pheaa.org/profiles/me/contacts/phones"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_TERMS}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/postTerms.json`
			url: "https://profile.api.{{env}}.pheaa.org/profiles/me/terms-of-use"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_CODES_COUNTRY}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/countryCodes.json`
			url: "https://profile.api.{{env}}.pheaa.org/codes/country"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_CODES_STATE}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/stateCodes.json`
			url: "https://profile.api.{{env}}.pheaa.org/codes/state"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_INBOX}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/getInbox.json`
			url: "https://documents.api.{{env}}.pheaa.org/inbox"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_INBOX_DOCUMENT_BY_ID}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/getInboxDocumentsById.json`
			url: "https://documents.api.{{env}}.pheaa.org/documents/{{docId}}"
		}
	},
	[`${API_NSP_PROFILE}.${API_NSP_OPERATION_INBOX_TAX_SUMMARY_BY_ID}`]: {
		default: {
			// url: `${process.env.PUBLIC_URL}/api/response/getInboxTaxSummaryById.json`
			url: "https://documents.api.{{env}}.pheaa.org/tax-summaries/{{taxSummaryId}}"
		}
	}
};

export const getApiConfigForNspAndOperation = (nsp, nspOperation) => {
	try {
		const config = api[`${nsp.toLowerCase()}.${nspOperation.toLowerCase()}`];
		return config.hasOwnProperty(ENV.currentEnv) ? config[ENV.currentEnv] : config.default;
	} catch (e) {
		console.warn("Cannot retrieve API configuration:", e);
		return { url: false, method: false };
	}
};

export const getApiUrl = (nsp, nspOperation, additionalReplacements = []) => {
	try {
		const config = getApiConfigForNspAndOperation(nsp, nspOperation);
		let returnUrl = ENV.replaceAuthClientIdTokenInUrl(ENV.replaceEnvTokenInUrl(config.url));

		if (isArrayOfLength(additionalReplacements)) {
			additionalReplacements.forEach(({ token, value }, i) => {
				if (isStringOfLength(token) && isOfLength(value)) {
					returnUrl = tokenReplacement(returnUrl, token, value);
				}
			});
		}

		return returnUrl;
	} catch (e) {
		console.warn("Cannot retrieve API URL:", e);
		return "";
	}
};